import React from "react";

import Search from "../components/Search";

function SearchPoem() {
  return <Search />;
}

export default SearchPoem;
